/* TokenAvatar (K3T-0 ring + K3O-0 badge). Art slot corners = black --canvas,
   NOT a gradient. Ring: bonding = green progress (--buy-delta); dex/migrated =
   full --warn. Badge: round, --bg-chip ground, source-logo inside. */
.avatar {
  position: relative;
  width: 52px;
  height: 52px;
  flex-shrink: 0;
}

.art {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 44px;
  height: 44px;
  border-radius: var(--radius-avatar);
  overflow: clip;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--canvas);
  color: var(--text-hi);
  font-family: var(--font-sans);
  font-size: var(--fs-body);
  font-weight: var(--fw-bold);
  line-height: 18px;
}

.art img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.fallback {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.skeleton {
  position: absolute;
  inset: 0;
  background: var(--bg-chip);
}

.ring {
  position: absolute;
  top: 0;
  left: 0;
}

/* Round source badge (LRW-0 style). Ground = --bg-chip; the 1px ring colour is
   set inline per source via sourceRing (solid or gradient) using a
   background-clip border so it follows the circle. Every source shows its own
   logo, centred. */
.badge {
  position: absolute;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: var(--radius-full);
  background: var(--bg-chip); /* fallback; inline sets the gradient ring via background-clip */
  /* a whole-pixel rim, and no transform: the badge's smaller size (v8, 0.85 of
     its nominal) is set in whole pixels by badgeGeometry — scaled by CSS it
     sat on fractional pixels and blurred */
  border: 1px solid transparent;
  overflow: clip; /* clip the logo (incl. raster tonfun) to the circle */
}
/* migrated-from-launchpad: recolour the source logo gold to match the gold
   ring. brightness(0) flattens to a silhouette FIRST so it works for any source
   colour (incl. pure-white blum, which a hue-shift can't touch); then the
   invert/sepia/saturate/hue-rotate chain colorises that silhouette to gold. */
.badgeGold svg,
.badgeGold img {
  filter: brightness(0) saturate(100%) invert(80%) sepia(55%) saturate(620%) hue-rotate(357deg)
    brightness(1.02);
}
